export default __webpack_public_path__ + "static/media/042-falling-rocks.b57a4d80.png";